import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { UtilService } from './util.service';
import { Observable } from 'rxjs';

@Injectable()
export class EmployeeService {

  employee: any;
  exchangeBenefit: any;
  empId: any;
  constructor(
    private http: HttpService,
    private utilService: UtilService
  ) { }


  set employeeId(id) {
    this.empId = id;
  }

  get employeeId() {
    return this.empId;
  }

  set employeeDetails(data) {
    this.employee = data;
  }

  get employeeDetails() {
    return this.employee;
  }

  set exchangeBenefitDetails(data) {
    this.exchangeBenefit = data;
  }

  get exchangeBenefitDetails() {
    return this.exchangeBenefit;
  }

  // Benefit Functions
  getBenefitsList(page) {
    return this.http.get(`/benefit/getBenefitsList?page=${page}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getHotelsByHotelChain() {
    let hotelChainId = JSON.parse(localStorage.getItem('loggedInUser')).hotelChainId;
    return this.http.get(`/getHotelsByHotelChain/${hotelChainId}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getGenderSuffixes() {
    return this.http.get(`/employee/getGenderSuffixes`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  saveOrUpdateBenefit(data) {
    return this.http.post(`/benefit/saveOrUpdateBenefit`, data)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getBenefitById(benefitId) {
    return this.http.get(`/benefit/getBenefitById?benefitId=${benefitId}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  activateOrDeactivateBenefit(benefitIds, status) {
    return this.http.post(`/benefit/activateOrDeactivateBenefit/${status}`, benefitIds)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }


  // Employee Functions
  getLookupDataForEmployee() {
    return this.http.get(`/employee/getLookupDataForEmployee`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getEmployeeList(data) {
    return this.http.post(`/employee/getEmployeeList`, data)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getEmployeeById(empId) {
    return this.http.get(`/employee/getEmployeeById/${empId}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  activateOrDeactivateEmployee(benefitIds, status) {
    return this.http.post(`/employee/activateOrDeactivateEmployees/${status}`, benefitIds)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  saveOrUpdateEmployee(data) {
    return this.http.post(`/employee/saveOrUpdateEmployee`, data)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  importEmployees(data) {
    return this.http.post(`/employee/importEmployees`, data)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getEmployeeBookings(empId, data) {
    return this.http.post(`/employee/getEmployeeBookings/${empId}`, data)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }
  
  getEmployeeTransactionHistory(empId, data) {
    return this.http.post(`/employee/getEmployeeTransactionHistory/${empId}`, data)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getEmployeeCommentsByMemberId(empId, data) {
    return this.http.post(`/employee/getEmployeeCommentsByMemberId/${empId}`, data)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  saveEmployeeComments(data) {
    return this.http.post(`/employee/saveEmployeeComments`, data)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  activateOrDeactivateEmployeeComment(commentId, statusId) {
    return this.http.get(`/employee/activateOrDeactivateEmployeeComment/${commentId}/${statusId}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  // Exchange benefits
  getExchangeOfBenefitsLookupData() {
    return this.http.get(`/employee/getExchangeOfBenefitsLookupData`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getExchangeOfBenefitsList(data) {
    return this.http.post(`/employee/getExchangeOfBenefitsList`, data)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getExchangeOfBenefit(exchangeId) {
    return this.http.get(`/employee/getExchangeOfBenefit/${exchangeId}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  saveExchangeOfBenefit(data) {
    return this.http.post(`/employee/saveExchangeOfBenefit`, data)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  sendVoucher(id) {
    return this.http.get(`/employee/generateVocherAndSendEmail/${id}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  search(terms: Observable<string>) {
    return terms.debounceTime(400)
      .distinctUntilChanged()
      .switchMap(term => {
        if (term.length > 0) {
          return this.getEmployeeSearch(term);
        } else {
          return Observable.of({ error: 0, message: '', responseObj: [] })
        }
      });
  }

  getEmployeeSearch(term) {
    return this.http.get(`/employee/getEmployeeCodes/${term}`)
      .map(res => res.json())
      .catch(() => Observable.of({ error: 0, message: '', responseObj: [] }));
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/_services/employee.service.ts